import { forwardRef } from 'react';

export const IslandPortalHost = forwardRef(function IslandPortalHost(_props, ref) {
	return (
		<div
			ref={ref}
			data-island-portal-host=""
		/>
	);
});

IslandPortalHost.displayName = 'IslandPortalHost';
